export default __webpack_public_path__ + "static/media/ieeesb.89d9cfba.PNG";